import { Injectable, inject } from "@angular/core";
import { map } from "rxjs/operators";
import { BehaviorSubject, Subscription } from "rxjs";
import { EntityChangeEvent, EntityChangeType } from "./entity-change-event";
import { RxStompService } from "@app/services/webstomp/rx-stomp.service";

@Injectable({
  providedIn: "root"
})
export class StompRouterService {
  private stompService = inject(RxStompService);

  private _entityStreams: BehaviorSubject<any>[] = [];
  private _subscriptions: { [id: string]: Subscription } = {};

  public addSubscription(topic: string) {
    if (this._subscriptions[topic]) {
      return false;
    }
    this._subscriptions[topic] = this.stompService
      .watch(topic)
      .pipe(
        map((message) => {
          return message.body;
        })
      )
      .subscribe((msg_body: string) => {
        const msg_body_obj = JSON.parse(msg_body);
        const change: EntityChangeEvent = {
          id: msg_body_obj.id,
          entity: msg_body_obj.entity,
          action: <EntityChangeType>msg_body_obj.action,
          payload: msg_body_obj.payload
        };
        if (this._entityStreams[change.entity] !== undefined) {
          this._entityStreams[change.entity].next(change);
        }
      });
  }

  public removeSubscription(topic: string): boolean {
    if (this.isSubscribed(topic)) {
      this._subscriptions[topic].unsubscribe();
      delete this._subscriptions[topic];
      return true;
    }
    return false;
  }

  public isSubscribed(topic: string): boolean {
    return !!this._subscriptions[topic];
  }

  public getEntityStream(entity: string): BehaviorSubject<EntityChangeEvent> {
    // console.log("requesting entity stream: " + entity);
    if (this._entityStreams[entity] === undefined) {
      this._entityStreams[entity] = new BehaviorSubject<EntityChangeEvent>(
        null
      );
    }
    return this._entityStreams[entity];
  }
}
